<script lang="ts" setup>
import ImageZoom from '~/composables/use-image-zoom';
    const props = defineProps<{
        floorPlanImg: {
            mediaItemUrl: string,
            mediaDetails: {
                height: number,
                width: number
            }
        },
        floorPlanFlippedImg?: {
            mediaItemUrl: string,
            mediaDetails: {
                height: number,
                width: number
            }
        }
    }>();

    const isFlipped = ref(false);
    let imageZoomInstance: ImageZoom | null = null;

    const currentFloorPlan = computed(() => {
        return isFlipped.value && props.floorPlanFlippedImg
            ? props.floorPlanFlippedImg
            : props.floorPlanImg;
    });

    const initializeImageZoom = () => {
        // Clean up existing instance if it exists
        if (imageZoomInstance) {
            imageZoomInstance.destroy();
            imageZoomInstance = null;
        }

        // Reset flip state when switching variations
        isFlipped.value = false;

        // Create new instance with current prop value
        imageZoomInstance = new ImageZoom(isFlipped, props.floorPlanFlippedImg);
    };

    onMounted(() => {
        initializeImageZoom();
    });

    // Watch for changes to floorPlanFlippedImg prop and re-initialize
    watch(() => props.floorPlanFlippedImg, () => {
        initializeImageZoom();
    });

    // Clean up on component unmount
    onBeforeUnmount(() => {
        if (imageZoomInstance) {
            imageZoomInstance.destroy();
            imageZoomInstance = null;
        }
    });
</script>
<template>
    <div class="modal fade floor-plan-modal" tabindex="-1" aria-labelledby="floorPlanModalLabel" aria-hidden="true" id="floor-plan-modal">
        <div class="modal-dialog modal-fullscreen">
            <div class="modal-content">
                <div class="modal-body p-4">
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    
                    <div class="modal-image-container">
                        <div class="zoom-controls">
                            <button class="zoom-btn" id="zoom-out" title="Zoom Out">−</button>
                            <div class="zoom-level" id="zoom-level">100%</div>
                            <button class="zoom-btn" id="zoom-in" title="Zoom In">+</button>
                            <button class="zoom-btn" id="zoom-reset" title="Reset Zoom">⌂</button>
                            <button v-if="floorPlanFlippedImg" class="zoom-btn" id="flip-plan" title="Flip Plan">⇄</button>
                        </div>

                        <div class="modal-image" id="image-container">
                            <img id="modal-img"
                                 :src="currentFloorPlan?.mediaItemUrl"
                                 alt="Floor Plan"
                                 class="fit-container"
                                 :width="currentFloorPlan?.mediaDetails?.width"
                                 :height="currentFloorPlan?.mediaDetails?.height">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>